module.exports = __webpack_public_path__ + "img/calendar4-range.d6f95e89.svg";